var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-d9ea8f22-4841-4f04-aaf5-c18841cd8957",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1028 1027.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .uuid-98296bcf-b461-4714-8834-b2447c118c67 {\r\n        fill: url(#uuid-33a5bc9b-ab71-46bb-b21c-af37de850eb8);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-33a5bc9b-ab71-46bb-b21c-af37de850eb8",
    x1: 168.91,
    y1: 81.3,
    x2: 878.55,
    y2: 971.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a50026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9c0026"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#840029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#5c012d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#270233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150335"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-98296bcf-b461-4714-8834-b2447c118c67",
    d: "M514,1027.99C230.58,1027.99,0,797.42,0,513.99S230.58,0,514,0s514,230.58,514,513.99-230.58,514-514,514ZM514,103.97c-226.09,0-410.03,183.94-410.03,410.03s183.94,410.03,410.03,410.03,410.03-183.94,410.03-410.03S740.09,103.97,514,103.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleIcon);
export default __webpack_public_path__ + "static/media/CircleIcon.02f7f9f10052a3aba1e4c2ae3f2a7890.svg";
export { ForwardRef as ReactComponent };